import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import FormCreate from '../Failure/FormCreate'
import FormCreateCause from '../Causes/FormCreate'
import Select from "react-select";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";

class Show extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            showPopover: false,
            isLoaded: true,
            editFailure: false,
            showCreate: false,
            failure_id: "",
            id: "",
            causa_id: "",
            dataFailure: [],
        }
    }

    componentDidMount = () => {
        this.getDataFailure()
    }

    updateData = (data) => {
        this.setState({
            dataFailure: [...this.state.dataFailure, data],
        })
    }

    updateShowCrate = () => {
        this.setState({
            showCreate: false,
        })
    }

    //add update
    updateItem = failure => {
        this.setState({
            dataFailure: this.state.dataFailure.map(item => {
                if (failure.id === item.id) {
                    return {
                        ...item,
                        mode: failure.mode,
                        effect: failure.effect,
                        severity: failure.severity,
                    }
                }
                return item;
            })
        });
    }

    updateState = (state) => {
        this.setState({
            showPopover: state,
        })
    }

    clearValues = () => {
        this.setState({
            failure_id: "",
            causa_id: "",
            id: "",
        })
    }

    getDataFailure = () => {
        fetch(`/failure/get_failures/${this.props.activity.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    dataFailure: data.data,
                    showCreate: data.last.fallo,
                    isLoaded: false
                });
            });
    }

    deleteFailure = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/failure/failures/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.getDataFailure();
                        this.props.loadData();
                    });
            }
        });
    };

    deleteCause = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/failure/causes/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.getDataFailure();
                        this.props.loadData();
                    });
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-lg modal-dialog-centered rk-modal" backdrop={this.props.backdrop}>
                    <div className="rk-modal__header">
                        <span className="rk-modal__header-icon"><i className="fas fa-clipboard-list"></i></span>
                        <h5>{this.props.title}</h5>
                        <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>

                    <div className="rk-modal__body amef-modal">

                        {/* Actividad + agregar modo de fallo */}
                        <div className="amef-activity">
                            <div className="amef-activity__name">{this.props.activity.name}</div>
                            <button
                                id="PopoverLabels"
                                type="button"
                                className="rk-btn rk-btn--primary"
                                disabled={!this.state.showCreate}
                                onClick={() => this.setState({ showPopover: true })}
                            >
                                <i className="fas fa-plus"></i> Agregar modo de fallo
                            </button>
                        </div>

                        <UncontrolledPopover isOpen={this.state.showPopover} placement="bottom" target="PopoverLabels">
                            <PopoverHeader>Nuevo<a className="close-popover" onClick={() => this.setState({ showPopover: (!this.state.showPopover) })}> <i className="fas fa-times"></i></a></PopoverHeader>
                            <PopoverBody>
                                <FormCreate
                                    updateData={this.updateData}
                                    updateShowCrate={this.updateShowCrate}
                                    activity={this.props.activity}
                                    updateState={this.updateState}
                                    clearValues={this.clearValues}
                                    loadDataActivity={this.props.loadData}
                                    modeEdit={false}
                                    user={this.props.user}
                                    type_count={this.props.type_count}
                                />
                            </PopoverBody>
                        </UncontrolledPopover>

                        {/* Modos de fallo */}
                        {this.state.dataFailure.length >= 1 ? (
                            this.state.dataFailure.map((failure) => (
                                <div className="amef-fail" key={failure.id}>
                                    <div className="amef-fail__head">
                                        <div className="amef-fail__fields">
                                            <div className="amef-field">
                                                <span className="amef-field__label">Modo</span>
                                                <span className="amef-field__value">{failure.mode}</span>
                                            </div>
                                            <div className="amef-field">
                                                <span className="amef-field__label">Efecto</span>
                                                <span className="amef-field__value">{failure.effect}</span>
                                            </div>
                                            <div className="amef-field amef-field--sev">
                                                <span className="amef-field__label">Severidad</span>
                                                <span className="amef-badge amef-badge--sev">{failure.severity}</span>
                                            </div>
                                        </div>

                                        <div className="amef-fail__actions">
                                            <button
                                                id={`PopoverLegacy${failure.id}`}
                                                type="button"
                                                className="rk-btn rk-btn--soft"
                                                onClick={() => this.setState({ id: failure.id })}
                                            >
                                                <i className="fas fa-plus"></i> Agregar Causa
                                            </button>
                                            <button
                                                id={`Popover${failure.id}`}
                                                type="button"
                                                className="rk-icon-btn"
                                                title="Editar fallo"
                                                onClick={() => this.setState({ failure_id: failure.id })}
                                            >
                                                <i className="fas fa-pen"></i>
                                            </button>
                                            <button
                                                type="button"
                                                className="rk-icon-btn rk-danger"
                                                title="Eliminar fallo"
                                                onClick={() => this.deleteFailure(failure.id)}
                                            >
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>

                                    {failure.causes.length >= 1 && (
                                        <div className="amef-causes">
                                            {failure.causes.map((causa) => (
                                                <div className="amef-cause" key={causa.id}>
                                                    <div className="amef-cause__fields">
                                                        <div className="amef-field">
                                                            <span className="amef-field__label">Causa</span>
                                                            <span className="amef-field__value">{causa.cause}</span>
                                                        </div>
                                                        <div className="amef-field">
                                                            <span className="amef-field__label">Control</span>
                                                            <span className="amef-field__value">{causa.control}</span>
                                                        </div>
                                                    </div>

                                                    <div className="amef-stats">
                                                        <div className="amef-stat">
                                                            <span className="amef-stat__label">Ocurrencia</span>
                                                            <span className="amef-stat__val">{causa.ocurrency_score_first}</span>
                                                        </div>
                                                        <div className="amef-stat">
                                                            <span className="amef-stat__label">Detectabilidad</span>
                                                            <span className="amef-stat__val">{causa.detectability_score_first}</span>
                                                        </div>
                                                        <div className="amef-stat amef-stat--npr">
                                                            <span className="amef-stat__label">NPR</span>
                                                            <span className="amef-stat__val">{causa.npr_score_first}</span>
                                                        </div>
                                                    </div>

                                                    <div className="amef-cause__actions">
                                                        <button
                                                            id={`PopoverCause${causa.id}`}
                                                            type="button"
                                                            className="rk-icon-btn"
                                                            title="Editar causa"
                                                            onClick={() => this.setState({ causa_id: causa.id })}
                                                        >
                                                            <i className="fas fa-pen"></i>
                                                        </button>

                                                        {this.state.causa_id == causa.id && (
                                                            <UncontrolledPopover isOpen={this.state.causa_id == causa.id} placement="bottom" target={`PopoverCause${causa.id}`}>
                                                                <PopoverHeader>Editar Causa <a className="close-popover" onClick={() => this.setState({ causa_id: "" })}> <i className="fas fa-times"></i></a></PopoverHeader>
                                                                <PopoverBody>
                                                                    <FormCreateCause
                                                                        formValues={causa}
                                                                        clearValues={this.clearValues}
                                                                        loadData={this.getDataFailure}
                                                                        user={this.props.user}
                                                                        modeEdit={true}
                                                                        type_count={this.props.type_count}
                                                                    />
                                                                </PopoverBody>
                                                            </UncontrolledPopover>
                                                        )}

                                                        <button
                                                            type="button"
                                                            className="rk-icon-btn rk-danger"
                                                            title="Eliminar causa"
                                                            onClick={() => this.deleteCause(causa.id)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {this.state.failure_id == failure.id && (
                                        <UncontrolledPopover isOpen={this.state.failure_id == failure.id} placement="bottom" target={`Popover${failure.id}`}>
                                            <PopoverHeader>Editar Fallo <a className="close-popover" onClick={() => this.setState({ failure_id: "" })}> <i className="fas fa-times"></i></a></PopoverHeader>
                                            <PopoverBody>
                                                <FormCreate
                                                    updateData={this.updateData}
                                                    activity={this.props.activity}
                                                    clearValues={this.clearValues}
                                                    formValues={failure}
                                                    modeEdit={true}
                                                    updateItem={this.updateItem}
                                                    user={this.props.user}
                                                    type_count={this.props.type_count}
                                                />
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    )}

                                    {this.state.id == failure.id && (
                                        <UncontrolledPopover isOpen={this.state.id == failure.id} placement="bottom" target={`PopoverLegacy${failure.id}`}>
                                            <PopoverHeader>Agregar Causa <a className="close-popover" onClick={() => this.setState({ id: "" })}> <i className="fas fa-times"></i></a></PopoverHeader>
                                            <PopoverBody>
                                                <FormCreateCause
                                                    formValues={failure}
                                                    loadData={this.getDataFailure}
                                                    clearValues={this.clearValues}
                                                    id={this.state.id}
                                                    loadDataActivity={this.props.loadData}
                                                    modeEdit={false}
                                                    user={this.props.user}
                                                    type_count={this.props.type_count}
                                                />
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="rk-panel-empty">
                                <i className="far fa-folder-open"></i>
                                <p>No hay modos de fallo</p>
                            </div>
                        )}
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>Cerrar</button>
                    </div>

                </Modal>
            </React.Fragment>
        );
    }
}

export default Show;
